<template>
  <el-dialog
    title="数据导入"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form label-width="100px">
      <el-form-item label="文件上传">
        <el-button size="small" type="primary" @click="selectFile">
          上传
        </el-button>
        <div class="upload-area">
          <el-upload
            ref="upload"
            class="upload-demo"
            drag
            action="#"
            accept=".xlsx,.xls"
            :limit="1"
            :file-list="fileList"
            :http-request="uploadExcel"
            :on-remove="handleRemove"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处,或<em>点击上传</em></div>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">
        提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { importStoreDealRewardRateAPI } from "../api";

export default {
  name: "DealRewardRateImport",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      file: null,
      fileList: [],
      submitting: false,
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (!val) {
        this.reset();
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit("update:visible", false);
      }
    },
  },
  methods: {
    selectFile() {
      this.$refs.upload.$refs["upload-inner"].handleClick();
    },
    uploadExcel(param) {
      this.file = param.file;
    },
    handleRemove() {
      this.file = null;
      this.fileList = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    async handleSubmit() {
      if (!this.file) {
        this.$message.error("请选择文件");
        return;
      }

      this.submitting = true;
      try {
        const formData = new FormData();
        formData.append("file", this.file);
        await importStoreDealRewardRateAPI(formData);
        this.$message.success("导入成功");
        this.handleClose();
        this.$emit("success");
      } catch (error) {
        // 错误提示由 http 封装统一处理
      } finally {
        this.submitting = false;
      }
    },
    reset() {
      this.file = null;
      this.fileList = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-area {
  margin-top: 10px;
}
</style>
